var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{staticClass:"captive-form-list",attrs:{"list":_vm.list,"infiniteId":_vm.infiniteId,"headers":_vm.headers,"loading":_vm.loading},on:{"load":_vm.load},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('captive-forms-list-item',{attrs:{"item":slotProps.item},on:{"reload":_vm.reload}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }